import { connect } from 'react-redux'
import LightEntrepreneursComponent from '../../../components/employer/lightEntrepreneurs/lightEntrepreneurs.component'
import {
  getLightEntrepreneurs,
  setFavouriteEntrepreneurs,
  lightEntrepreneursPageChange,
  closeLightEntrepreneursSnackbar,
  getTotalApplications,
  offerAnAssignmentAgreement,
  closeAssignmentFormDialog,
  getAreaOfWork,
  previewNewAssignment,
  addNewAssignment,
  saveAssignmentAsDraft
} from '../../../actions/employer'
import { groupLightEntrepreneurByUuid } from '../../../utils/employer/lightEntrepreneurs.utils'

const mapStateToProps = (state) => {
  const lightEntre = groupLightEntrepreneurByUuid(
    state.lightEntrepreneurs.lightEntre
  )
  const emailArray = lightEntre.map((obj) => obj.email)
  return {
    state,
    lightEntre: lightEntre,
    selected: state.lightEntrepreneurs.selected,
    lightEntrepreneursPages: !!lightEntre
      ? Math.ceil(lightEntre.length / 10)
      : 0,
    showSuccessAddSnackbar: state.lightEntrepreneurs.showSuccessAddSnackbar,
    showFailedAddSnackbar: state.lightEntrepreneurs.showFailedAddSnackbar,
    showEmailAdded: state.lightEntrepreneurs.showEmailAdded,
    showEmailNotExist: state.lightEntrepreneurs.showEmailNotExist,
    // isCompleteForm: state.lightEntrepreneurs.isCompleteForm,
    areaOfWork: state.assignments.areaOfWork,
    emailArray,
    enableSaveButton: state.assignments.enableSaveButton,
    // offerToPerson: state.lightEntrepreneurs.offerToPerson,
    showPreviewNewAssignment: state.assignments.showPreview,
    showAddFavouriteEntrepreneursFailedSnackbar:
      state.lightEntrepreneurs.showAddFavouriteEntrepreneursFailedSnackbar,
    showRemoveFavouriteEntrepreneursFailedSnackbar:
      state.lightEntrepreneurs.showRemoveFavouriteEntrepreneursFailedSnackbar,
    selectedLERatings: state.lightEntrepreneurs.selectedLERatings
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getLightEntrepreneurs: (values) => dispatch(getLightEntrepreneurs(values)),
    setFavouriteEntrepreneurs: (values) =>
      dispatch(setFavouriteEntrepreneurs(values)),
    lightEntrepreneursPageChange: (selected) =>
      dispatch(lightEntrepreneursPageChange(selected)),
    closeLightEntrepreneursSnackbar: () =>
      dispatch(closeLightEntrepreneursSnackbar()),
    getTotalApplications: () => dispatch(getTotalApplications()),
    offerAnAssignmentAgreement: (selected) =>
      dispatch(offerAnAssignmentAgreement(selected)),
    closeAssignmentFormDialog: () => dispatch(closeAssignmentFormDialog()),
    getAreaOfWork: () => dispatch(getAreaOfWork()),
    previewNewAssignment: (values) => dispatch(previewNewAssignment(values)),
    addNewAssignment: (values) => dispatch(addNewAssignment(values)),
    saveAssignmentAsDraft: (values) => dispatch(saveAssignmentAsDraft(values))
  }
}

const LightEntrepreneursContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LightEntrepreneursComponent)

export default LightEntrepreneursContainer
